export default "__VITE_ASSET__16876e92__"